import MuiButton from '@mui/material/Button';
import MuiMenu from '@mui/material/Menu';
import { styled } from '@mui/material/styles';

export const Button = styled(MuiButton)(() => ({
  alignItems: 'center',
  justifyContent: 'center',

  '&.MuiButton-root': {
    borderRadius: '0.5rem',
    height: '3.75rem',
    paddingInline: '0',
    width: '3.75rem'
  },
  '&.MuiButton-root:hover': {
    '& img.active': {
      opacity: 1
    },
    '& img.default': {
      opacity: 0
    }
  }
}));

export const Menu = styled(MuiMenu)(({ theme }) => ({
  '& li > *': {
    flexGrow: 1,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    maxWidth: '100%',
    padding: '0 1.5rem',

    [theme.breakpoints.up('lg')]: {
      fontSize: '1.375rem'
    }
  },

  '& .MuiListItem-root .profile-info': {
    [theme.breakpoints.up('lg')]: {
      paddingBlock: '0.25rem'
    }
  },

  '& .MuiPaper-root': {
    borderRadius: '1rem',
    boxShadow: '0 0.25rem 1rem 0.125rem rgba(0, 0, 0, 0.12)',
    marginBlockStart: '0.25rem',
    width: 'calc(100% - 2rem)'
  },
  '& .MuiList-root': {
    paddingBlock: '1rem'
  },
  [theme.breakpoints.up('sm')]: {
    '& .MuiPaper-root': {
      maxWidth: '22rem'
    }
  },
  [theme.breakpoints.up('lg')]: {
    '& .MuiPaper-root': {
      maxWidth: '30rem'
    }
  }
}));
